<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.training-proposal.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <table class="ir-plugin-table" *ngIf="trainingProposals && trainingProposals.length > 0">
      <tbody style="vertical-align: top">
        <tr class="th-plugin-line--subheader">
          <td width="35%">
            <span>{{ 'plugins.training-proposal.module' | translate }}</span>
          </td>
          <td width="25%">
            <span>{{ 'plugins.training-proposal.trainee' | translate }}</span>
          </td>
          <td width="5%">
            <span
              >{{ 'plugins.training-proposal.duration' | translate }} ({{
                'plugins.training-proposal.days' | translate
              }})</span
            >
          </td>
          <td width="35%">
            <span>{{ 'plugins.training-proposal.when' | translate }}</span>
          </td>
        </tr>
        <tr class="th-plugin-line--content" *ngFor="let item of trainingProposals">
          <td width="35%">
            <span>{{ item.Course }}</span>
          </td>
          <td width="25%">
            <span [innerHtml]="getSelectedValues(item.Trainees)"></span>
          </td>
          <td width="5%">
            <span>{{ item.Time }}</span>
          </td>
          <td width="35%">
            <span>{{ item.Moment }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
